// extracted by mini-css-extract-plugin
export default {"bannerImagesWrapper":"BannerWrapper_bannerImagesWrapper__yZVfS"};